module.exports = __webpack_public_path__ + "img/1x.b92db82.jpg";